__turbopack_context__.v({
  "areaTextField": "breederVerifierPage-module-scss-module__YNPP6q__areaTextField",
  "areaTextFieldInput": "breederVerifierPage-module-scss-module__YNPP6q__areaTextFieldInput",
  "areaTextFieldInputContainer": "breederVerifierPage-module-scss-module__YNPP6q__areaTextFieldInputContainer",
  "areaTextFieldLabel": "breederVerifierPage-module-scss-module__YNPP6q__areaTextFieldLabel",
  "asterisk": "breederVerifierPage-module-scss-module__YNPP6q__asterisk",
  "form": "breederVerifierPage-module-scss-module__YNPP6q__form",
  "formButton": "breederVerifierPage-module-scss-module__YNPP6q__formButton",
  "formButtonContainer": "breederVerifierPage-module-scss-module__YNPP6q__formButtonContainer",
  "formContainer": "breederVerifierPage-module-scss-module__YNPP6q__formContainer",
  "formIcon": "breederVerifierPage-module-scss-module__YNPP6q__formIcon",
  "formIconWrapper": "breederVerifierPage-module-scss-module__YNPP6q__formIconWrapper",
  "formInput": "breederVerifierPage-module-scss-module__YNPP6q__formInput",
  "formInputLabel": "breederVerifierPage-module-scss-module__YNPP6q__formInputLabel",
  "formInputs": "breederVerifierPage-module-scss-module__YNPP6q__formInputs",
  "formResults": "breederVerifierPage-module-scss-module__YNPP6q__formResults",
  "formResultsContainer": "breederVerifierPage-module-scss-module__YNPP6q__formResultsContainer",
  "formResultsText": "breederVerifierPage-module-scss-module__YNPP6q__formResultsText",
  "formRow": "breederVerifierPage-module-scss-module__YNPP6q__formRow",
  "formShare": "breederVerifierPage-module-scss-module__YNPP6q__formShare",
  "formTitle": "breederVerifierPage-module-scss-module__YNPP6q__formTitle",
  "intro": "breederVerifierPage-module-scss-module__YNPP6q__intro",
  "introText": "breederVerifierPage-module-scss-module__YNPP6q__introText",
  "introTitle": "breederVerifierPage-module-scss-module__YNPP6q__introTitle",
  "introTitleBold": "breederVerifierPage-module-scss-module__YNPP6q__introTitleBold",
  "introTitleText": "breederVerifierPage-module-scss-module__YNPP6q__introTitleText",
  "playIcon": "breederVerifierPage-module-scss-module__YNPP6q__playIcon",
  "reference": "breederVerifierPage-module-scss-module__YNPP6q__reference",
  "shell": "breederVerifierPage-module-scss-module__YNPP6q__shell",
  "successMessage": "breederVerifierPage-module-scss-module__YNPP6q__successMessage",
  "successMessageText": "breederVerifierPage-module-scss-module__YNPP6q__successMessageText",
  "textField": "breederVerifierPage-module-scss-module__YNPP6q__textField",
  "textFieldInput": "breederVerifierPage-module-scss-module__YNPP6q__textFieldInput",
  "textFieldInputContainer": "breederVerifierPage-module-scss-module__YNPP6q__textFieldInputContainer",
  "textFieldLabel": "breederVerifierPage-module-scss-module__YNPP6q__textFieldLabel",
  "textLink": "breederVerifierPage-module-scss-module__YNPP6q__textLink",
  "videoCard": "breederVerifierPage-module-scss-module__YNPP6q__videoCard",
  "videoThumbnail": "breederVerifierPage-module-scss-module__YNPP6q__videoThumbnail",
  "videoTitle": "breederVerifierPage-module-scss-module__YNPP6q__videoTitle",
  "videoTitleNarrow": "breederVerifierPage-module-scss-module__YNPP6q__videoTitleNarrow",
  "videoWrapper": "breederVerifierPage-module-scss-module__YNPP6q__videoWrapper",
  "videos": "breederVerifierPage-module-scss-module__YNPP6q__videos",
});
